import React, { useRef, useState } from "react";

const Tooltip = ({ text, children, delay = 200 }) => {
  const [show, setShow] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    timeoutRef.current = setTimeout(() => {
      setShow(true);
    }, delay);
  };

  const handleMouseLeave = () => {
    clearTimeout(timeoutRef.current);
    setShow(false);
  };

  return (
    <div className="relative overflow-visible top-0 left-0 inline-table">
      <div
        className="initial z-50"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
      {show && (
        <div
          className="bg-gray-300 text-gray-800 px-0 py-0 rounded text-xs whitespace-nowrap overflow-visible"
          style={{
            position: "absolute",
            top: "-100%",
            left: "0%",
            transform: "translateX(-100%)",
            background: "rgba(0, 0, 0, 0.7)",
            color: "#fff",
            padding: "5px",
            border: "white",
            borderRadius: "4px",
            zIndex: 999,
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
